/** Bottom nav — viditelná pod 768px (mobile).
 *  4 ikony: Dashboard / Aufträge / Rechnungen / Karte. */

import { NavLink } from "react-router";
import { Ic, type IconKey } from "@/components/ui/icons";
import { t } from "@/i18n/de";

const ITEMS: { to: string; label: string; icon: IconKey }[] = [
  { to: "/", label: t.nav.dashboard, icon: "Dashboard" },
  { to: "/orders", label: t.nav.orders, icon: "Stack" },
  { to: "/invoices", label: t.nav.invoices, icon: "Receipt" },
  { to: "/map", label: t.nav.map, icon: "Map" },
];

export function BottomNav() {
  return (
    <nav
      className="bottom-nav"
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        height: 60,
        background: "var(--bg-card)",
        borderTop: "1px solid var(--border)",
        display: "flex",
        zIndex: 30,
      }}
    >
      {ITEMS.map((it) => {
        const Icon = Ic[it.icon];
        return (
          <NavLink key={it.to} to={it.to} end={it.to === "/"} className="bn-item">
            {({ isActive }: { isActive: boolean }) => (
              <>
                <span
                  style={{
                    color: isActive ? "var(--gold)" : "var(--text-3)",
                  }}
                >
                  <Icon size={20} />
                </span>
                <span
                  style={{
                    fontSize: 10.5,
                    color: isActive ? "var(--gold-hi)" : "var(--text-3)",
                    fontWeight: 500,
                    marginTop: 2,
                  }}
                >
                  {it.label}
                </span>
                {isActive && (
                  <span
                    style={{
                      position: "absolute",
                      top: 0,
                      left: "20%",
                      right: "20%",
                      height: 2,
                      background: "var(--gold)",
                      borderRadius: "0 0 2px 2px",
                    }}
                  />
                )}
              </>
            )}
          </NavLink>
        );
      })}
      <style>{`
        .bn-item {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          position: relative;
        }
      `}</style>
    </nav>
  );
}
